import { createSelectFieldsDto, type SelectFieldsInterface } from '@zaoblako/shared/common/dtos/select-fields.dto';
import { ExternalUserFindDto, type ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

/** Registry columns for external users BASIS (`select` filter / column picker). */
export type ExternalUserRegistryColumnKey =
  | 'profile.name'
  | 'profile.email'
  | 'profile.phone'
  | 'profile.currentTelegramChat'
  | 'client'
  | 'job'
  | 'contragents'
  | 'accessCards'
  | 'isMailingEnabled'
  | 'banned';

export const EXTERNAL_USER_REGISTRY_COLUMN_KEYS: ExternalUserRegistryColumnKey[] = [
  'profile.name',
  'profile.email',
  'profile.phone',
  'profile.currentTelegramChat',
  'client',
  'job',
  'contragents',
  'accessCards',
  'isMailingEnabled',
  'banned',
];

/** Default visible registry columns for external users BASIS (`select` filter). */
export const EXTERNAL_USER_REGISTRY_DEFAULT_SELECT: ExternalUserRegistryColumnKey[] = [
  'profile.name',
  'client',
  'job',
  'contragents',
  'accessCards',
  'isMailingEnabled',
  'banned',
];

/** API-only `select` keys for widgets / dropdowns (not registry column picker keys). */
export const EXTERNAL_USER_WIDGET_API_SELECT_KEYS = [
  'id',
  'accessControl',
] as const satisfies readonly (keyof ExternalUserFindInterface)[];

/** Registry `select` for card widgets and dropdowns (client / contragent). */
export const EXTERNAL_USER_WIDGET_REGISTRY_SELECT = [
  'id',
  'profile',
  'accessControl',
  'job',
  'contragents',
  'isMailingEnabled',
  'banned',
  'deleted',
] as const satisfies readonly (keyof ExternalUserFindInterface)[];

/** External users BASIS registry column selection - DTO signature */
export type ExternalUserRegistrySelectInterface = SelectFieldsInterface<ExternalUserFindInterface>;

/** External users BASIS registry column selection - DTO schema */
export const ExternalUserRegistrySelectDto = createSelectFieldsDto(
  SecurityDtoKeysEnum.EXTERNAL_USER_REGISTRY_SELECT_DTO,
  ExternalUserFindDto,
  {
    maxDepth: 2,
    default: [...EXTERNAL_USER_REGISTRY_DEFAULT_SELECT] as (keyof ExternalUserFindInterface)[],
    // Registry column key for TG-bot status (nested relation, not a scalar leaf in ProfileFindDto)
    extraKeyPatterns: [/^profile\.currentTelegramChat$/],
  },
);
